import { useEffect, useState } from 'react'
import { Locale } from 'date-fns'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { createCustomDatePickerLocale } from 'utils/createCustomDatePickerLocale'
import { isRtlSelector } from 'redux/selectors/general'

export const useDateRangeLocale = (useCustomTranslations: boolean = true): Locale | undefined => {
  const [dateRangeLocale, setDateRangeLocale] = useState<Locale>()
  const locale = useSelector((state: RootState) => state.general.locale)
  const translations = useSelector((state: RootState) => state.config.translations)
  const isRtl = useSelector(isRtlSelector)

  useEffect(() => {
    const loadLocale = async () => {
      if (useCustomTranslations) {
        const customLocale = createCustomDatePickerLocale({
          locale,
          translations,
          isRtl,
        })
        setDateRangeLocale(customLocale)
      } else {
        setDateRangeLocale(undefined)
      }
    }

    loadLocale()
  }, [locale, useCustomTranslations, translations, isRtl])

  return dateRangeLocale
}
